<template>
  <!--多项填空-->
  <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">多项填空</p>
    <el-row :gutter="10" class="question-box">
      <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
        {{ question.quesIndex + 1 }}
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
      >
        <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				
        <TitleEditor 
          :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
      </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<template>
					<el-dropdown v-if="!$route.query.bankId" @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
						<span class="el-dropdown-link">
							<el-tooltip content="收藏到题库" placement="top" effect="light">
                <i v-if="question.isedit && !question.bqid"  class="el-icon-star-off to-bank item"></i>
							</el-tooltip>
						</span>
						<el-dropdown-menu slot="dropdown">
							<div class="scroll-body" style="overflow-y: auto;" :style="{maxHeight: isAddBank ? '102px' : '200px'}">
							<el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
								<span>{{item.name}}</span>
								<el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
							</el-dropdown-item>
							<el-dropdown-item 
								disabled
								style="
								font-size: 12px;
								color: #ccc"
								class="dropdown-item" 
								v-if="bankList.length == 0">
								<span>暂无题库</span>
							</el-dropdown-item>
							</div>

							<el-dropdown-item v-if="isAddBank" divided style="text-align:center">
							<el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
								<el-form-item
								prop="name"
								:rules="[
									{ required: true, message: '不能为空'},
								]"
								>
								<el-input size="mini" v-model="bankForm.name"></el-input>
								</el-form-item>
								<el-form-item  size="mini" style="text-align: right;margin-bottom: 0;">
								<el-button type="text" @click="addBank">创建</el-button>
								<el-button  type="text" @click="cancelAddBank">取消</el-button>
								</el-form-item>
							</el-form>
							</el-dropdown-item>
							
							<el-dropdown-item divided style="text-align:center">
							<el-button  @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tooltip content="取消收藏" placement="top" effect="light">
						<i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid"  @click="delFormBank"></i>
					</el-tooltip>
				</template>
				<template v-if="!isBankViewTest">
					<div @click="() => $emit('jumpshow', question)">
						<el-badge 
							v-if="question.logicalSettings.num" 
							:value="question.logicalSettings.num" 
							class="item">
							<i class="el-icon-share"  ></i>
						</el-badge>
					</div>
					<i  class="el-icon-rank item drag-handle"></i>
					<i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyClick(question)"></i>
					<i class="el-icon-delete delete" v-if="question.isedit" @click="questiondel(question.qid)"></i>
				</template>
			</el-col>
    </el-row>

    <draggable 
      v-bind="draggableOptions"
      class="drag-container" 
      v-model="question.optionList" 
    >
      <transition-group tag="div" type="transition" :name="'flip-list'">
        <el-row
          :gutter="10"
          style="margin-top: 12px !important; margin-bottom: 10px"
          v-for="(childItem, childindex) in question.optionList"
          :key="index + '_' + childindex"
        >
          <div @click="setEditOptionIndex(childindex)">
            <el-row>
              <el-col
                :xs="16"
                :sm="16"
                :md="16"
                :lg="16"
                :xl="16"
                class="el_item_option item_container_title"
                style="margin-left: 50px"
              >
              
                <span v-if="isBankViewTest">{{childItem.labelName}}</span>
                <TitleEditor 
                  v-if="!isBankViewTest" 
                  class="outline-none" 
                  :qid="childItem.oid" 
                  :class="childItem.oid"  
                  :value="childItem.labelName" 
                  @childValueChange="(val) => labelNameChange(val, childItem)" 
                ></TitleEditor>
              </el-col>
              <el-col
                :xs="3"
                :sm="3"
                :md="3"
                :lg="3"
                :xl="3"
                class="el_item_option item_container_title"
                v-if="editOptionIndex == index + '_' + childindex && question.optionList.length != 1"
              >
                <i class="option-handle el-icon-rank el-icon-common-option" ></i>
                <i
                  class="el-icon-s-tools el-icon-common-option"
                  @click.stop="
                    wjsetquestionoption(childItem)
                  "
                ></i>
                <i
                  class="el-icon-remove el-icon-common-option"
                  @click="
                    wjdelquestionoption(childItem.oid)
                  "
                ></i>
              </el-col>
            </el-row>
          </div>
          <div @click="setEditOptionIndex(childindex)">
            <el-row style="margin-left: 50px">
              <el-col
                :xs="16"
                :sm="16"
                :md="16"
                :lg="16"
                :xl="16"
                class="el_item_option item_container_title"
              >
                <el-input 
                  size="small" 
                  disabled 
                  type="textarea"
                  resize="none"
                  v-model="childItem.userAnswer"
                  :rows="childItem.inputHeight == '小' ? 1 : (childItem.inputHeight == '中' ? 2 : 3)"
                ></el-input>
                <!-- <div class="inputvalue"></div> -->
              </el-col>
              <el-col
                :xs="3"
                :sm="3"
                :md="3"
                :lg="3"
                :xl="3"
                class="el_item_option item_container_title"
              >
              </el-col>
            </el-row>
          </div>
        </el-row>
      </transition-group>
    </draggable>
        <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-if="question.isedit && !isBankViewTest"
    >
      <el-col
        :xs="16"
        :sm="16"
        :md="16"
        :lg="16"
        :xl="16"
        class="el_item_option item_container_title"
        style="margin-left: 50px"
      >
        <i
          class="el-icon-plus el-icon-common"
          @click="wjaddquestionoption"
          >添加选项</i
        >
        <i
          class="el-icon-s-fold el-icon-common"
          @click="$refs.batchAdd.batchAddshow = true"
          >批量添加</i
        >
        <i
          class="el-icon-menu el-icon-common"
          @click="addOther"
          >添加【其他】</i
        >
      </el-col>
    </el-row>
    
		<BatchAddOption 
			ref="batchAdd"
			:title="'填空'" 
			:functionName="'batchAdd'"
      :question="question"
			@batchAdd="batchAdd"
		/>
  </div>
</template>
<script>
// import DragMixin from "@/components/DragMixin";
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import BatchAddOption from "@/components/myComponents/batchAddOption/batchAddOption.vue"
export default {
	components: {
    TitleEditor,
		BatchAddOption
	},
  data() {
    return {};
  },
  props: {
    question: {},
    editOptionIndex: { type: String, default: "0_0" },
    editIndex: { type: Number, default: 0 },
    index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
		bankList: {
			type: Array,
			default: () => {
			return []
			}
		},
  },
  data() {
    return {
      value: '',
      input: '',
			draggableOptions: {
				handle: '.option-handle'
			},
      // 题库start
			isAddBank: false,
			bankForm: {
				isSystemBank: 0, // 我的题库
				name: '',
				type: '未分类',
            	bankType: 1
			}
      // 题库end
    }
  },
  watch: {
    'question.questionsName':{
			handler(newV, oldV){
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = ''
				}
			},
			deep: true
		},
    'question.optionList.length':{
			handler(newV, oldV){
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = ''
				}
			},
			deep: true
		}
  },
	mounted(){
		const unwatch = this.$watch('question.optionList', {
      handler(newValue) {
        this.question.optionList = this.question.optionList.map((info) =>{
          this.$set(info, 'isDefault', false)
          return info
        })
        unwatch()
      },
      deep: true
    });
	},
  methods: {
	  copyClick(question){
	  	this.$emit('questionCopy',question)
	  },
    labelNameChange(val, option) {
      if (val !== option.labelName && this.question.bqid) {
        this.question.bqid = ''
      }
      option.labelName = val
    },
		// 题库start
		getBankList(e) {
			if (e) {
				this.$emit('getBankList')
			}
		},
		addToBank(id) {
			this.$refs.bankDropdown.hide()
			this.$emit('addToBank', this.question, id)
			console.log(this.question)
		},
		cancelAddBank() {
			this.isAddBank = false
			this.bankForm.name = ''
		},
		addBank() {
			this.$refs.ValidateForm.validate((valid) => {
				if (valid) {
					this.isAddBank = true
					this.$emit('addBank', this.bankForm, this.question.qid)
				} else {
					console.log('error submit!!');
					return false;
				}
				});
			// this.$refs.bankDropdown.show()
		},
		delFormBank() {
			this.$emit('delFormBank', this.question)
		},
		// 题库end
    updateQuestion() {
      this.$emit("wjupdquestionoption", this.question);
    },
    batchAdd(optionArr) {
      this.$emit("wjaddquestionoption", this.question.qid, optionArr, this.question.questionsTypeId);
    },
    wjaddquestionoption() {
      this.$emit("wjaddquestionoption", this.question.qid, [`新增填空`], this.question.questionsTypeId);
    },
    addOther(){
      this.$emit("wjaddquestionoption", this.question.qid, ['其他'], this.question.questionsTypeId)
    },
    // 选项设置
    wjsetquestionoption(option) {
      this.$emit("wjsetquestionoption", this.question, option)
    },
    wjdelquestionoption(oid) {
      this.$emit("wjdelquestionoption", { qid: this.question.qid, oid });
    },
    showAdvance(e) {
      this.$emit("showAdvance", e);
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
      this.$emit("setEditOptionIndex", childIndex);
    },
    questiondel(id) {
      this.$emit("questiondel", id);
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 10px;
  font-size: 22px !important;
  line-height: 35px !important;
  color: cornflowerblue;
  cursor: pointer;
}



/deep/.el-textarea .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
.outline-none{
  /* display: inline-block; */
  outline: none;
  // max-width: 73%;
}
/deep/.el-input.is-disabled .el-input__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
</style>
